import { useEffect, useState } from 'react'
import { useAuth, useInstance, useView } from '@10000/react'
import { Dashboard, Tenant, Tenants } from './'
import { Shell, Background } from '../layout'
import { Account, Billing, Organisations, Subscription, Teams, Users } from '../admin/settingsType'
import { Box } from '../widgets'

export const SuperRouter = ({ region }) => {
  const params = new URLSearchParams(window.location.search)
  const [id, setId] = useState(params.get('id'))

  const { user } = useAuth()
  const { setInstance } = useInstance()
  const { company } = useView('tenant')

  useEffect(() => {
    if(id) {
      setInstance({
        id: id,
        region: user.region
      })
    } else {
      const url = new URL(window.location.href)
      url.searchParams.delete('id')
      window.history.replaceState({}, '', url)
    }
  }, [id, user.region, setInstance])

  const onTenantChange = newTenant => {
    setId(newTenant)
    setInstance({
      id: newTenant,
      region: user.region
    })

    const url = new URL(window.location.href)
    if(!id) {
      if(newTenant) {
        url.searchParams.set('id', newTenant)
      } else {
        url.searchParams.delete('id')
      }
    }

    window.history.replaceState({}, '', url)
  }

  return (
    <Box fullWidth fullHeight maxHeight="100dvh" maxWidth="100dvw">
      <Background>
        <Shell>
          {id
            ? <TenantDashboard setTenant={onTenantChange} tenantId={id} region={region} companyName={company?.name} />
            : <Dashboard setTenant={onTenantChange} options={[{ title: 'Tenants', icon: 'Company', component: Tenants }]} />
          }
        </Shell>
      </Background>
    </Box>
  )
}

const TenantDashboard = ({ setTenant, companyName }) => (
  <Dashboard
    title={companyName}
    goBack={() => setTenant('')}
    options={[
      { title: 'Overview', icon: 'Settings', component: Tenant },
      { title: 'Account', icon: 'User', component: Account },
      { title: 'Subscription', icon: 'Rocket', component: Subscription },
      { title: 'Billing', icon: 'PaymentCard', component: Billing },
      { title: 'Organisations', icon: 'Company', component: Organisations },
      { title: 'Teams', icon: 'Network', component: Teams },
      { title: 'Users', icon: 'Team', component: Users }
    ]}
  />
)